/**
 * Carrossel do order bump do cart drawer.
 *
 * Este arquivo precisa ser carregado SEMPRE (inclusive com o carrinho vazio).
 * O snippet order-bump.liquid so e renderizado quando ha itens no carrinho,
 * entao manter a definicao do custom element la dentro fazia com que, na
 * primeira adicao de produto, o elemento chegasse ao DOM via innerHTML sem
 * nunca ter sido definido -- e scripts inseridos por innerHTML nao executam.
 */
(function () {
  'use strict';

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    // swiper-bundle carrega com defer; pode ainda nao estar disponivel quando
    // o bump chega por AJAX. Aguarda sem depender de DOMContentLoaded, que
    // pode ja ter disparado ha muito tempo.
    var tries = 0;
    var timer = setInterval(function () {
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  class OrderBumpSwiper extends HTMLElement {
    connectedCallback() {
      this._swiper = null;
      whenSwiperReady(this._init.bind(this));
    }

    disconnectedCallback() {
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }
    }

    _init() {
      if (typeof Swiper === 'undefined') return;
      if (!this.isConnected || this._swiper) return;

      var el = this.querySelector('.order-bump__swiper');
      if (!el) return;

      this._swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 5,
        loop: false,
        pagination: { el: this.querySelector('.order-bump__pagination'), clickable: true },
      });
    }
  }

  if (!customElements.get('order-bump-swiper')) {
    customElements.define('order-bump-swiper', OrderBumpSwiper);
  }
})();
